<template>
  <fieldset
    :class="{'field_item':true,
    'field_icon_Enabled':fieldIcon?true:false,
    'item_onfocus ':onFocusClass}"
  >
    <label :for="label" class="label">
      {{label}}
      <span v-if="isRequired" class="required">*</span>
    </label>
    <input
      :required="required"
      :readonly="readonly"
      :name="name"
      :type="type"
      v-model="value"
      @keyup="onKeyUp"
      @blur="onBlur"
      @focus="onFocus"
      :maxlength="maxLength"
      :minlength="minLength"
    />
    <span class="error" v-if="errorMsg">{{errorMsg}}</span>
  </fieldset>
</template>
<script>
export default {
  props: [
    "label",
    "name",
    "type",
    "callback",
    "fieldIcon",
    "errorMsg",
    "id",
    "inputValue",
    "minLength",
    "maxLength",
    "readonly",
    "minVal",
    "maxVal",
    "required"
  ],
  name: "Textfield",
  data: function() {
    return {
      onFocusClass: false,
      isRequired: false,
      value: ""
    };
  },
  methods: {
    onFocus(el) {
      if (this.inputValue || el) {
        this.onFocusClass = true;
      }
    },
    onBlur() {
      if (!this.value) {
        this.onFocusClass = false;
        this.value = this.inputValue;
      }
    },
    onKeyUp(el) {
      const {value}= el.target;
      this.value = this.trim(value);
    //   this.callback(this.value,this.id,el.key==='Enter');
    },
    trim(val) {
      return val && val.length ? val.replace(/\s+/g, "") : val;
    }
  },
  watch: {
    value: function(val) {
      this.value = this.trim(val);
      if (this.value && this.value.length) {
        this.onFocusClass = true;
      }
      this.callback(this.value, this.id);
    },
    inputValue: {
      handler: function(newV, oldV) {
        if (newV !== oldV) {
          this.value = newV;
          this.onFocus();
        }
      },
      immediate: true
    }
  }
};
</script>

 <style lang="scss" scoped >
.field_item {
  position: relative;
  margin: 15px 0 70px;
  padding: 10px 0;
  border: none;
  border-bottom: 2px solid rgba($white, 0.2);
  .label {
    position: absolute;
    z-index: 1;
    top: 10px;
    left: 0px;
    font-size: 1.5em;
    transform: translateY(50%);
    transition: 0.1s;
    color: $white;
  }
  input {
    position: relative;
    z-index: 2;
    height: 40px;
    width: 100%;
    padding: 0px;
    font-size: 1.6em;
    font-weight: 600;
    background: none;
    outline: none;
    border: none;
    color: $white;
  }

  input:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset;
    -webkit-box-shadow: 0 0 0 30px white inset;
  }
  input:-webkit-autofill + label {
    left: 0;
    font-size: 0.8em;
    color: $white;
    transform: translateY(-110%);
  }
  .error {
    position: absolute;
    color: $error;
    font-size: 1em;
    font-weight: 500;
    left:0;
    bottom:-25px;
  }
  &.item_onfocus {
    border-bottom: 2px solid rgba($white, 0.8);
    label {
      left: 0;
      font-size: 1em;
      color: $white;
      transform: translateY(-110%);
    }
  }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
